<template>
    <section class="row-12">
        <div class="col-6 col-sm-12">
            <h3>Tworzenie nowego konspektu</h3>
            <p>Proces towrzenia jest niezywkle prosty, jeśli jednak masz z czymś kłopoty zachęcamy do zapoznania się z
                naszym poradnikiem (link znajdziesz w stopce, na dole strony).</p>
            <form class="form-align-right m-t-2">
                <label>Temat konspektu *</label>
                <input type="text" v-model="conspectData.title" placeholder="Temat konspektu" autofocus required>
                <label>Opis konspektu *</label>
                <textarea placeholder="Opisz swój konspekt w kilku słowach np. rozwijając jego temat."
                          v-model="conspectData.description"></textarea>
                <folder-select ref="folders" folderType="conspects" v-model="conspectData.folder"></folder-select>
                <div class="row-12 w-100">
                    <div class="col-6 col-sm-12 ">
                        <label>Data *</label>
                        <input type="text" id='conspect_date' placeholder="Data odbycia się treningu"
                               class="datepicker"/>
                    </div>
                    <div class="col-6 col-sm-12 ">
                        <label>Sezon *</label>
                        <input type="text" placeholder="Sezon, w którym odbył się trening"
                               v-model="conspectData.season"/>
                    </div>
                </div>
                <div class="row-12 w-100">
                    <div class="col-6 col-sm-12 ">
                        <label>Drużyna *</label>
                        <input type="text" placeholder="Drużyna trenująca" v-model="conspectData.team"/>
                    </div>
                    <div class="col-6 col-sm-12 ">
                        <label>Trener *</label>
                        <input type="text" placeholder="Trener prowadzący trening" v-model="conspectData.coach"/>
                    </div>
                </div>
                <label>Liczba zawodników *</label>
                <div class="row-12 w-100">
                    <input class="col-6 col-sm-12" type="number" placeholder="Minimum" min="1"
                           v-model="conspectData.player[0]"/>
                    <input class="col-6 col-sm-12" type="number" placeholder="Maksimum" min="1"
                           v-model="conspectData.player[1]"/>
                </div>
                <div class="row-12 w-100">
                    <div class="col-6 col-sm-12 ">
                        <label>Obciążenie *</label>
                        <select v-model="conspectData.weight">
                            <option value="Niskie">Niskie</option>
                            <option value="Średnie">Średnie</option>
                            <option value="Wysokie">Wysokie</option>
                            <option value="Bardzo wysokie">Bardzo wysokie</option>
                        </select>
                    </div>
                    <div class="col-6 col-sm-12 ">
                        <label>Obiekt sportowy *</label>
                        <input placeholder="Lokalizacja odbycia się treningu" type="text" v-model="conspectData.place"/>
                    </div>
                </div>
                <label>Grafika</label>
                <div class="row-12 w-100">
                    <div class="col-6 col-sm-12 center-flex-a">
                        <div class="input-file-container">
                            <input class="input-file" id="club_logo" type="file">
                            <label tabindex="0" for="club_logo" class="input-file-trigger">Wybierz plik...</label>
                        </div>
                        <p class="file-return"></p>
                    </div>
                    <div class="col-6 col-sm-12">
                        <p>Możesz wgrać logo/herb zespołu, a pojawi się ono na konspekcie.</p>
                    </div>
                </div>
                <div class="row-12 w-100">
                    <p class="col-12 m-b-5">Poniższe pola będą uzuepłniane <b>automatycznie</b> jak tylko dodasz
                        odpowiednie elementy do konspektu na osi czasu. Zawsze na sam koniec możesz je edytować według
                        Twoich preferencji.</p>
                    <div class="col-12">
                        <label>Sprzęt sportowy</label>
                        <input-tag class="col-12"
                                   style="width: calc( 100% - 20px ); padding: 12px; border:none; margin: 5px 0;"
                                   placeholder="Sprzęt wymagany do zrealizowania konspektu. Wpisz pojedynczy element i naciśnij enter."
                                   :limit="10" :tags.sync="conspectData.equipment"></input-tag>
                    </div>
                </div>
                <small class="m-t-2 w-100">* pola wymagane</small>
                <button @click.prevent="saveConspect">Zapisz zmiany</button>
            </form>
        </div>
        <div class="col-6 col-sm-12">
            <div class="card">
                <div class="card-body">
                    <h3 class="m-t-1" v-if="conspectData.title.length>0">{{conspectData.title}}</h3>
                    <h3 class="m-t-1" v-else>Wprowadź temat konspektu</h3>
                    <p class="text-third-d" v-if="conspectData.description.length>0">{{conspectData.description}}</p>
                    <p class="text-third-d" v-else>Wprowadź opis w formularzu, aby zobaczyć podgląd.</p>
                    <small class="text-primary" v-if="conspectData.time[0]!==conspectData.time[1]">
                        {{conspectData.time[0]}}-{{conspectData.time[1]}}min.
                    </small>
                    <small class="text-primary" v-else>{{conspectData.time[1]}} min.</small>
                </div>
            </div>
            <div class="ct-main-container">
                <div class="ct-block" v-for="(element, mainIndex) in conspectElements">
                    <div class="ct-block-name">
                        <div class="ct-block-name-content">
                            <small class="ct-block-name-time" v-if="element.time[0]!==element.time[1]">
                                {{element.time[0]}}-{{element.time[1]}}min.
                            </small>
                            <small class="ct-block-name-time" v-else>{{element.time[1]}} min.</small>
                            <p class="ct-block-name-text">{{element.name}}</p>
                        </div>
                        <div class="ct-block-name-hr"></div>
                        <div class="ct-block-name-circle"></div>
                    </div>
                    <div class="ct-block-content">
                        <div class="ct-block-list-container">
                            <draggable v-model="element.elements"
                                       :options="{draggable:'.ct-block-list-element',handle:'.ct-block-list-element-icon'}">
                                <transition-group>
                                    <div v-for="(listElement, childIndex) in element.elements" :key="childIndex"
                                         class="ct-block-list-element">
                                        <div class="ct-block-list-element-icon"><i class="i-menu"></i></div>
                                        <div class="ct-block-list-element-text" style="font-size: 13px;">
                                            {{listElement.name}}<br/>
                                            <small style=" color: #778098">{{listElement.description}}</small>
                                        </div>
                                        <small class="ct-block-list-element-time"
                                               v-if="listElement.time[0]!==listElement.time[1]">
                                            {{listElement.time[0]}}-{{listElement.time[1]}}min.
                                        </small>
                                        <small class="ct-block-list-element-time" v-else>{{listElement.time[1]}} min.
                                        </small>
                                        <div class="ct-block-list-element-delete"
                                             @click="deleteListElement(childIndex,mainIndex)"><i class="i-cross"></i>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>
                            <div slot="footer" class="ct-block-list-element-add" @click="addListElement(mainIndex)">
                                +
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="addListElementModal">
            <div class="modal-header">
                Dodawanie elementu
            </div>
            <div class="modal-body">
                <p class="">Możesz dodać do konspektu proste pole tekstowe (bez szkicu) lub projekt, który przygotowałeś
                    wcześniej w kreatorze.</p>
                <div class="m-x-a" style="max-width: 360px;">
                    <button class="w-100 m-0" @click="showAddField('#addExistProjectModal')">Wybór istniejącego
                        projektu
                    </button>
                    <button class="w-100 m-0 m-t-2" @click="showAddField('#addSimpleFieldModal')">Proste pole tekstowe
                    </button>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#addListElementModal')">Anuluj</button>
            </div>
        </div>
        <div class="modal" id="addSimpleFieldModal">
            <div class="modal-header">
                Dodawanie prostego pola tekstowego
            </div>
            <div class="modal-body">
                <form action="">
                    <label>Tytuł</label>
                    <input type="text" placeholder="Krótki tytuł" v-model="simpleField.title"/>
                    <label>Wskazówki</label>
                    <textarea type="text" placeholder="Wskazówki" v-model="simpleField.description"></textarea>
                    <label>Czas wykonania (minuty)</label>
                    <div class="row-12 w-100">
                        <div class="col-6 col-sm-12">
                            <input type="number" placeholder="Minimum" v-model="simpleField.time[0]"/>
                        </div>
                        <div class="col-6 col-sm-12">
                            <input type="number" placeholder="Maksimum" v-model="simpleField.time[1]"/>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#addSimpleFieldModal')">Anuluj</button>
                <button @click="addSimpleField()">Dodaj</button>
            </div>
        </div>
        <div class="modal" id="addTimeToExist">
            <div class="modal-header">
                Czas trwania wybranego projektu.
            </div>
            <div class="modal-body">
                <form action="">
                    <label>Czas trwania (minuty)</label>
                    <div class="row-12 w-100">
                        <div class="col-6 col-sm-12">
                            <input type="number" placeholder="Minimum" v-model="addedElement.time[0]"/>
                        </div>
                        <div class="col-6 col-sm-12">
                            <input type="number" placeholder="Maksimum" v-model="addedElement.time[1]"/>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#addTimeToExist')">Anuluj</button>
                <button @click="addTimeToProject()">Dodaj</button>
            </div>
        </div>

        <div class="modal" id="addExistProjectModal">
            <div class="modal-header">
                Dodawanie istniejącego projektu
            </div>
            <div class="modal-body row-12" style="max-width: 600px">
                <div class="card m-b-3 col-6 col-sm-12" v-for="(project, index) in projects" >
                    <div class="card-image">
                        <img :src="project.main_image" :alt="project.name">
                    </div>
                    <div class="card-body" style="position: relative;">
                        <button class="select-button-in-card" @click="selectProject(index)">Wybierz</button>
                        <h4 class="m-t-1">{{project.name}}</h4>
                        <p v-if="project.description.length > 0"> {{project.description}} </p>
                        <p v-else> Ten projekt nie posiada opisu. Przejdź do edycji, aby go uzupełnić.</p>
                    </div>
                </div>
                <div class="col-12" >
                    <h3 class="text-a-c" v-if="projects.length === 0">Niestety nie posiadasz jeszcze żadnych projektów które możesz użyć.</h3>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#addExistProjectModal')">Anuluj</button>
            </div>
        </div>
    </section>
</template>

<script>
    import draggable from 'vuedraggable';
    import InputTag from 'vue-input-tag'
    import FolderSelect from '../../components/FolderSelect'

    export default {
        components: {
            draggable,
            InputTag,
            'folder-select': FolderSelect
        },
        data: function () {
            return {
                projects: [],
                simpleField: {
                    title: "",
                    description: "",
                    time: [null, null]
                },
                addedElementMain: -1,
                selectedAddElement: "",
                addedElement: {time: [null, null]},
                conspectData: {
                    title: "",
                    weight: 'Niskie',
                    description: "",
                    time: [null, null],
                    player: [null, null],
                    team: "",
                    coach: "",
                    folder: null,
                    date: null,
                    season: '',
                    place: '',
                    equipment: []
                },
                conspectElements: [
                    {
                        name: "Część wstępna",
                        time: [0, 0],
                        elements: []
                    }, {
                        name: "Część główna",
                        time: [0, 0],
                        elements: []
                    }, {
                        name: "Część końcowa",
                        time: [0, 0],
                        elements: []
                    }
                ]
            };
        },
        methods: {
            saveConspect() {
                this.conspectData.date = $("#conspect_date").val();
                try {
                    let valid = new Validator({
                        "temat konspektu": this.conspectData.title,
                        "opis": this.conspectData.description,
                        "czas minimalny": "" + this.conspectData.time[0],
                        "czas maksymalny": "" + this.conspectData.time[1],
                        "minimalna ilość osób": "" + this.conspectData.player[0],
                        "maksymalna ilośc osób": "" + this.conspectData.player[1],
                        "drużyna": this.conspectData.team,
                        "trener": this.conspectData.coach,
                        "folder": this.conspectData.folder,
                        "data": "" + this.conspectData.date,
                        "sezon": this.conspectData.season,
                        "miejsce": this.conspectData.place,
                    });
                    valid.get("temat konspektu").length(3, 255);
                    valid.get("opis").length(10);
                    valid.get("czas minimalny").length(1, 10);
                    valid.get("folder").isNotNull();
                    valid.get("czas maksymalny").length(1, 10);
                    valid.get("minimalna ilość osób").length(1, 100);
                    valid.get("maksymalna ilośc osób").length(1, 100);
                    valid.get("drużyna").length(3, 255);
                    valid.get("trener").length(3, 255);
                    valid.get("data").length(3, 255);
                    valid.get("sezon").length(3, 255);
                    valid.get("miejsce").length(3, 255);

                    if (this.conspectElements[0].elements.length === 0 && this.conspectElements[1].elements.length === 0 && this.conspectElements[2].elements.length === 0) {
                        notify.createNotifier("Musisz dodać chociaż jedno pole do konspektu, abyśmy mogli stworzyć dla Ciebie plik .pdf.", "danger", 4000);
                        throw "validate failed";
                    }

                    if(parseInt(this.conspectData.player[0]) === NaN || parseInt(this.conspectData.player[1]) === NaN){
                        notify.createNotifier("Niepoprawne liczby w polach liczby zawodników","danger",4000);
                        throw "Niepoprawne liczby w polach liczby zawodników";
                    }

                    if (parseInt(this.conspectData.player[0]) > parseInt(this.conspectData.player[1])) {
                        notify.createNotifier("Minimalna ilość osób nie może być większa od maksymalnej ilości.", "danger", 4000);
                        throw "Zbyt duza wartosc minimalna";
                    }

                } catch (e) {
                    return false;
                }

                if ($('#club_logo').val().length > 0) {
                    let reader = new FileReader();
                    reader.readAsDataURL($('#club_logo')[0].files[0]);
                    reader.onload = () => {
                        this.conspectData.img = reader.result;
                        this.saveEnd(true);
                    };
                } else {
                    this.saveEnd(false);
                }
            },
            saveEnd(withImg = false) {
                axios.put(`conspect/${this.$route.params.id}`, {
                    login_token: AuthMiddleware.user.login_token,
                    title: this.conspectData.title,
                    img: withImg ? this.conspectData.img : null,
                    description: this.conspectData.description,
                    time_min: this.conspectData.time[0],
                    time_max: this.conspectData.time[1],
                    player_min: this.conspectData.player[0],
                    player_max: this.conspectData.player[1],
                    team: this.conspectData.team,
                    coach: this.conspectData.coach,
                    folder: this.conspectData.folder,
                    weight: this.conspectData.weight,
                    date: this.conspectData.date,
                    place: this.conspectData.place,
                    equipment: this.conspectData.equipment,
                    season: this.conspectData.season,
                    conspect_elements: this.conspectElements
                })
                    .then((response) => {
                        notify.createNotifier("Konspekt utworzony pomyślnie.", "success", 4000);
                        this.$router.push('/conspect-list');
                    }).catch(() => {
                    notify.createNotifier("Coś poszło źle. Spróbuj jeszcze raz.", "danger", 4000);
                })
            },
            selectProject(index) {
                this.hideModal('#addExistProjectModal');

                this.addedElement = {
                    id: this.projects[index].id,
                    name: this.projects[index].name,
                    description: this.projects[index].description,
                    time: [null, null],
                    index: index
                };

                this.showModal('#addTimeToExist');
            },
            strip(html) {
                let tmp = document.createElement("DIV");
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || "";
            },
            addTimeToProject() {

                try {
                    let valid = new Validator({
                        "czas minimalny": this.addedElement.time[0],
                        "czas maksymalny": this.addedElement.time[1],
                    });
                    valid.get("czas minimalny").isNotNull();
                    valid.get("czas maksymalny").isNotNull();

                    if (parseInt(this.addedElement.time[0]) > parseInt(this.addedElement.time[1])) {
                        notify.createNotifier("Czas minimalny nie może być większy od maksymalnego", "danger", 4000);
                        throw "Zbyt duza wartosc minimalna";
                    }

                    if(parseInt(this.addedElement.time[0]) === 0 || parseInt(this.addedElement.time[1]) === 0 ){
                        notify.createNotifier("Czas trwania nie może być równy 0","danger",4000);
                        throw "Czas trwania nie może być równy 0";
                    }

                } catch (e) {
                    return false;
                }

                this.hideModal('#addTimeToExist');

                this.conspectElements[this.addedElementMain].elements.push({
                    id: this.addedElement.id,
                    name: this.addedElement.name,
                    description: this.addedElement.description,
                    time: [parseInt(this.addedElement.time[0]), parseInt(this.addedElement.time[1])]
                });

                this.projects[this.addedElement.index].equipment.filter(x => {
                    let indeks = this.conspectData.equipment.indexOf(x.toLowerCase());
                    if (indeks === -1) {
                        this.conspectData.equipment.push(x.toLowerCase());
                    }
                });

                this.addedElement = {time: [null, null]};
                this.updateListTIme();
            },
            addSimpleField() {

                try {
                    let valid = new Validator({
                        "tytuł": this.simpleField.title,
                        "czas minimalny": this.simpleField.time[0],
                        "czas maksymalny": this.simpleField.time[1],
                    });
                    valid.get("tytuł").length(3, 255);
                    valid.get("czas minimalny").isNotNull();
                    valid.get("czas maksymalny").isNotNull();
                    valid.get("czas minimalny").length(1, 10);
                    valid.get("czas maksymalny").length(1, 10);

                    if (parseInt(this.simpleField.time[0]) > parseInt(this.simpleField.time[1])) {
                        notify.createNotifier("Czas minimalny nie może być większy od maksymalnego", "danger", 4000);
                        throw "Zbyt duza wartosc minimalna";
                    }
                    if(parseInt(this.simpleField.time[0]) === 0 || parseInt(this.simpleField.time[1]) === 0 ){
                        notify.createNotifier("Czas trwania nie może być równy 0","danger",4000);
                        throw "Czas trwania nie może być równy 0";
                    }


                } catch (e) {
                    return false;
                }

                this.hideModal('#addSimpleFieldModal');
                this.conspectElements[this.addedElementMain].elements.push({
                    id: -1,
                    name: this.simpleField.title,
                    description: this.simpleField.description,
                    time: [parseInt(this.simpleField.time[0]), parseInt(this.simpleField.time[1])]
                });

                this.simpleField = {
                    title: "",
                    description: "",
                    time: [null, null]
                };

                this.updateListTIme();
            },
            showAddField(name) {
                this.hideModal('#addListElementModal');
                this.showModal(name);
            },
            updateListTIme() {
                this.conspectData.time = [0, 0];
                if (this.conspectElements)
                    for (let i = this.conspectElements.length - 1; i >= 0; i--) {
                        this.conspectElements[i].time = [0, 0];
                        for (let z = this.conspectElements[i].elements.length - 1; z >= 0; z--) {
                            this.conspectElements[i].time[0] += parseInt(this.conspectElements[i].elements[z].time[0]);
                            this.conspectElements[i].time[1] += parseInt(this.conspectElements[i].elements[z].time[1]);
                        }
                        this.conspectData.time[0] += parseInt(this.conspectElements[i].time[0]);
                        this.conspectData.time[1] += parseInt(this.conspectElements[i].time[1]);
                    }
            },
            addListElement(mainId) {
                this.addedElementMain = mainId;
                this.showModal("#addListElementModal");
            },
            deleteListElement(childId, mainId) {
                this.conspectElements[mainId].elements.splice(childId, 1);
                this.updateListTIme();
            },
            showModal(name) {
                $(name).showModal()
            },
            hideModal(name) {
                $(name).hideModal()
            }
        },
        mounted: function () {
            $(document).ready(() => {
                axios.get(`conspect/${this.$route.params.id}`)
                    .then((response) => {
                        this.conspectElements = JSON.parse(response.data.conspect_elements);
                        this.conspectData = {
                            title: response.data.title,
                            weight: response.data.weight,
                            description: response.data.description,
                            time: [response.data.time_min, response.data.time_max],
                            player: [response.data.player_min, response.data.player_max],
                            team: response.data.team,
                            folder: response.data.folder_id,
                            coach: response.data.coach,
                            date: response.data.date,
                            season: response.data.season,
                            place: response.data.place,
                            equipment: response.data.equipment
                        };

                        setTimeout(()=>{
                            this.$refs.folders.select(response.data.folder_id);
                        },500);

                        $('.datepicker').datetimepicker({
                            autoclose: true,
                            format: 'Y-m-d H:i'
                        });

                        $('.datepicker').val(moment(response.data.date).format('Y-M-D HH:mm'));

                        this.conspectData.equipment = this.conspectData.equipment.length > 3 ? JSON.parse(this.conspectData.equipment) : [];

                        axios.get(`animations`)
                            .then((response) => {
                                this.projects = response.data;
                                for (let i = this.projects.length - 1; i >= 0; i--) {
                                    this.projects[i].equipment = this.projects[i].equipment.length > 3 ? JSON.parse(this.projects[i].equipment) : [];
                                    this.projects[i].description = this.strip(this.projects[i].description);
                                    this.projects[i].tips = this.strip(this.projects[i].tips);
                                }
                            })
                    });
            });
        }
    }
</script>

<style>

    .vue-input-tag-wrapper .input-tag {
        color: #fff !important;
        background-color: #6e52a8 !important;
        border: none !important;
        padding: 5px !important;
    }

    .vue-input-tag-wrapper .input-tag .remove {
        color: #fff !important;
        padding-left: 5px;
    }

    .ct-block-list-container {
        width: 100%;
    }

    .ct-block-list-element-icon {
        width: 30px;
        cursor: pointer;
    }

    .ct-block-list-element-delete {
        cursor: pointer;
    }

    .ct-block-list-element-delete:hover {
        color: #6e53a8;
    }

    .ct-block-list-element {
        display: flex;
        align-items: center;
        padding: 0 10px;
        justify-content: space-between;
    }

    .ct-block-list-element-text {
        width: 100%;
        padding: 10px;
    }

    .ct-block-list-element-time {
        padding: 0 10px;
        color: #6e53a8;
        width: 95px;
    }

    .ct-block-list-element {
        list-style: none;
        background: #fbfbfb;
        border-radius: 5px;
        margin: 10px 0 10px 15px;
        min-height: 35px;
    }

    .select-button-in-card {
        position: absolute;
        top: -25px;
        left: calc(50% - 12px);
        transform: translateX(-50%);
    }

    .ct-block-list-element-add {
        list-style: none;
        background: #fbfbfb;
        border-radius: 5px;
        margin: 10px 0 10px 15px;
        min-height: 35px;
    }

    .ct-block-list-element-add {
        cursor: pointer;
        text-align: center;
        line-height: 33px;
    }

    .ct-block-list-element-add:hover {
        transform: scale(1.02) translateY(-2px);
        color: #6e53a8;
        font-weight: 900;
        box-shadow: 2px 1px 11px -3px #afafaf;
    }

    .ct-block {
        min-height: 140px;
        display: flex;
        align-items: center;
    }

    .ct-block-name {
        position: relative;
        width: 110px;
        align-self: stretch;
        align-items: center;
        display: flex;
        flex-wrap: wrap;
    }

    .ct-block-name-content {
        display: flex;
        flex-wrap: wrap;
    }

    .ct-block-content {
        width: calc(100% - 110px);
        min-height: 140px;
        margin: 15px 0;
        justify-content: center;
        display: flex;
        align-items: center;
    }

    .ct-block-name-hr {
        position: absolute;
        right: 14px;
        height: 100%;
        top: 0;
        width: 2px;
        background: #cecece;
    }

    .ct-block-name-circle {
        width: 30px;
        height: 30px;
        background: #6e53a8;
        border-radius: 50%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }

    p.ct-block-name-text {
        margin: 0;
        width: 100%;
        padding-right: 35px;
        text-align: right;
    }

    small.ct-block-name-time {
        color: #6e53a8;
        width: 100%;
        padding-right: 35px;
        text-align: right;
    }


</style>